{
  "platforms": {
    "bigcommerce": "BigCommerce",
    "custom": "Custom",
    "magento": "Magento",
    "shopify": "Shopify",
    "shopify_plus": "Shopify",
    "sparklayer": "SparkLayer",
    "wix": "Wix",
    "woocommerce": "WooCommerce"
  },
  "bytes": "bytes",
  "drop-images": "Drop your images here",
  "file-upload": "{count, plural, =1 {Click or drop to replace} other {Click or drop more files}}",
  "feature_restricted": "Feature is not available",
  "feature_not_enabled": "Feature is not enabled",
  "none_selected": "None set",
  "none": "None",
  "no_results": "No values found",
  "no_results_custom_value": "No matches - your text will be used as entered",
  "available_on": "Available on:",
  "currency": "Currency",
  "inherit": "Inherit",
  "b2b": "b2b",
  "plans": {
    "development": "Development",
    "basic_free": "Basic",
    "v2_basic": "Starter",
    "v2_starter_plus": "Starter",
    "v2_growth": "Growth",
    "v2_pro": "Pro",
    "enterprise": "Enterprise",
    "enterprise_onboarding": "Enterprise",
    "custom": "Custom"
  },
  "staff-only": "✨ Staff only"
}
